import React from "react";

const YSVLogo = ({ size = "md", showText = true, showSubtext = false, imgSize, textSize }) => {
  const sizes = {
    xs: { img: 24, text: 16, gap: 4 },
    sm: { img: 28, text: 18, gap: 6 },
    md: { img: 36, text: 22, gap: 8 },
    lg: { img: 48, text: 28, gap: 10 },
    xl: { img: 64, text: 36, gap: 12 },
    xxl: { img: 120, text: 48, gap: 14 },
    // hero scales with viewport so it fills space on desktop but never overflows on phones.
    hero: { img: "clamp(96px, 26vw, 200px)", text: "clamp(72px, 22vw, 160px)", gap: "clamp(10px, 2.5vw, 22px)" },
  };
  const preset = sizes[size] || sizes.md;
  const s = { ...preset, img: imgSize ?? preset.img, text: textSize ?? preset.text };

  return (
    <div data-testid="ysv-logo" style={{ display: 'flex', alignItems: 'center', gap: s.gap }}>
      <img
        src="/ysv-logo.jpg"
        alt="YSV"
        style={{
          width: s.img,
          height: s.img,
          borderRadius: typeof s.img === "number" ? s.img * 0.2 : 18,
          objectFit: 'cover',
        }}
      />
      {showText && (
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <span style={{
            fontFamily: "'Outfit', sans-serif",
            fontWeight: 800,
            fontSize: s.text,
            lineHeight: 0.9,
            color: 'var(--cyan)',
            letterSpacing: '0.02em',
          }}>YSV</span>
          {showSubtext && (
            <p style={{ fontSize: typeof s.text === "number" ? Math.max(10, s.text * 0.18) : "clamp(10px, 2.2vw, 16px)", color: 'var(--text-secondary)', marginTop: 4 }}>Youth Sports Video</p>
          )}
        </div>
      )}
    </div>
  );
};

export default YSVLogo;
